import screenfull from '@/util/util.full-screen'
import { onBeforeUnmount } from '@vue/composition-api'
export const useFullScreen = () => {
  const html = document.documentElement
  let fnHandle = null
  // 是否全屏
  const isFullScreen = () => {
    return screenfull.isFullscreen
  }

  // 是否全屏
  const exitFullScreen = () => {
    if (screenfull.isEnabled) {
      screenfull.exit()
    }
  }

  const setFullScreenToggle = (el = document.documentElement, options = {}) => {
    if (screenfull.isEnabled) {
      screenfull.toggle(el, options)
    }
  }
  const setFullScreen = (el = html, options = {}) => {
    if (screenfull.isEnabled) {
      screenfull.request(el, options)
    }
  }
  const onChange = (callback) => {
    fnHandle = callback
    if (screenfull.isEnabled) {
      screenfull.on('change', callback)
    }
  }
  const removeChange = (callback) => {
    if (screenfull.isEnabled) {
      screenfull.off('change', callback)
    }
  }
  const onError = (callback) => {
    if (screenfull.isEnabled) {
      screenfull.on('error', (event) => {
        callback(event)
      })
    }
  }
  onBeforeUnmount(() => {
    removeChange(fnHandle)
  })
  return {
    onChange,
    onError,
    removeChange,

    setFullScreen,
    setFullScreenToggle,
    exitFullScreen,

    isFullScreen
  }
}
